export const projects = [
  {
    img: "https://raw.githubusercontent.com/tushar07-dev/Clone-of-myHours/main/Website%20sneak%20peeks/Homepage.png",
    title: "myHours-Clone",
    des: "Full stack web application clone to coordinate projects sells and tasks to create project report for clients .",
    demo: "",
    live: "myhours01.netlify.app/",
    gitHub: "https://github.com/tushar07-dev/Clone-of-myHours",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "MongoDB",
      "NodeJS",
      "Express",

    ],
  },
  {
    img: "https://camo.githubusercontent.com/06e1a1b190508b3a5fd8e0cfc82d1ba846f15ef5996da7a2edc935268ab6fd10/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313430302f312a4955617472696469576543522d7a48374678664246772e6a706567",
    title: "Calendary-Clone",
    des: "A website which schedules meetings professionally and efficiently.",
    demo: "",
    live: "calendly-react-clone.netlify.app/",
    gitHub: "https://github.com/tushar07-dev/Calendary_clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React"
    ],
  },
  {
    img: "https://raw.githubusercontent.com/tushar07-dev/Fitmeals/main/img.jpeg",
    title: "Fitmeals-Clone",
    des: "This is the clone of the Fitmeals website. A web application to buy Healthy food and diet plan. This is our team collaboration project at Full Stack-development Bootcamp in Masai School.",
    demo: "",
    live: " https://fitmeals-project.netlify.app/",
    gitHub: "https://github.com/tushar07-dev/Fitmeals",
    technologies: ["HTML", "CSS", "JavaScript", "NodeJS"],
  },
  {
    img: "https://camo.githubusercontent.com/026c48765cd0c0a230b36f6b5fcf5b027e259b7eaaa6b17c635daea6ffe757f7/68747470733a2f2f696d67732e7365617263682e62726176652e636f6d2f424e522d315041584d773462677238473636684b42764e35497676566e4f6a687a725034736c49334a68672f72733a6669743a3736383a3438303a312f673a63652f6148523063484d364c79396a5a4734792f4c6d4a76645852706358566c4c6d68312f62574a735a5746755a484a70593267752f593239744c3364774c574e76626e526c2f626e5176645842736232466b637938792f4d4445354c7a41304c3031765a47567a2f5a57357a4c5445744e7a5934654451342f4d433571634763",
    title: "Modesens-Clone",
    des: "An e-commerce website which offers various fashion clothing’s for all age and gender",
    demo: "",
    live: "https://graceful-starlight-17a7a2.netlify.app//",
    gitHub: "https://github.com/tushar07-dev/Modesens-Clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "NodeJS",
    ],
  }
];
